import { Chip, Stack, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const options = [
    {
        label: 'Normal',
        value: 'normal'
    },
    {
        label: 'High',
        value: 'high'
    }
]

export const OptionsContrast = (props) => {
    const { onChange, value } = props

    return (
        <Stack spacing={1}>
            <Typography
                color="text.secondary"
                variant="overline"
                sx={{ mt: 4 }}
            >
                Contrast
            </Typography>
            <Stack alignItems="center" direction="row" flexWrap="wrap" gap={2}>
                {options.map((option) => (
                    <Chip
                        key={option.label}
                        label={option.label}
                        onClick={() => onChange?.(option.value)}
                        sx={[
                            {
                                borderColor: 'transparent',
                                borderStyle: 'solid',
                                borderWidth: 2
                            },
                            option.value === value && {
                                borderColor: 'primary.main'
                            }
                        ]}
                    />
                ))}
            </Stack>
        </Stack>
    )
}

OptionsContrast.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.oneOf(['normal', 'high'])
}
